<template>
  <!-- Dialog - Create / Edit -->
  <v-dialog
    v-model="dialog"
    width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-toolbar>
      <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-alert
          class="ma-4"
          type="warning"
          v-for="item in handleError.items"
          :key="item"
          close-icon
        >
          {{ item }}
        </v-alert>
        <v-form ref="form" v-model="valid" lazy-validation autocomplete="off">
          <!-- ========================================= -->
          <!--             Registration form             -->
          <!-- ========================================= -->
          <v-subheader class="overline pt-4">{{
            $t("registrationForm")
          }}</v-subheader>
          <div class="pa-4 px-6">
            <v-text-field
              :label="$t('fullNameLabel')"
              v-model="form.fullName"
              :rules="fullNameRules"
              required
              clearable
              outlined
              dense
              autofocus
            ></v-text-field>
          </div>
          <!-- ========================================= -->
          <!--                CredentialS                -->
          <!-- ========================================= -->
          <v-subheader class="overline pt-4">{{
            $t("accessCredential")
          }}</v-subheader>
          <div class="pa-4 px-6">
            <v-text-field
              :label="$t('labelLogin')"
              v-model="form.login"
              :rules="usernameRules"
              required
              clearable
              outlined
              dense
              autocapitalize="off"
            ></v-text-field>

            <template v-if="edit">
              <v-btn @click="editPassword = !editPassword" class="mb-3">
                {{ $t("btnChangePassword") }}
              </v-btn>
            </template>
            <template v-if="editPassword || !edit">
              <v-text-field
                :class="[
                  !form.password || show ? 'show-password' : 'hide-password',
                ]"
                :label="$t('passwordLabel')"
                v-model="form.password"
                :rules="passwordRules"
                required
                clearable
                outlined
                dense
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show = !show"
                type="text"
                :counter="8"
                maxlength="8"
                autocapitalize="off"
              ></v-text-field>
              <v-text-field
                :class="[
                  !form.confirmPassword || show1
                    ? 'show-password'
                    : 'hide-password',
                ]"
                :label="$t('confirmPassword')"
                v-model="form.confirmPassword"
                :rules="confirmPasswordRules"
                required
                clearable
                outlined
                dense
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show1 = !show1"
                type="text"
                :counter="8"
                maxlength="8"
                autocapitalize="off"
              ></v-text-field>
            </template>
          </div>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :loading="loading"
          v-on:click.prevent="updateLocal"
          type="submit"
          :disabled="!valid"
        >
          {{ $t("btnSave") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { validate } from "@/util/validate";
export default {
  name: "regional-manager-users-local-manager-update",
  data: () => ({
    // Utils
    valid: false,
    show: false,
    show1: false,
    loading: false,
    editPassword: false,
    // Form data:
    form: {
      fullName: "",
      login: "",
      password: "",
      confirmPassword: "",
    },
    // Validate Forms:
    fullNameRules: [validate.required, validate.max],
    usernameRules: [
      validate.required,
      validate.usernameMax,
      validate.usernameAz09,
      validate.max,
    ],
    passwordRules: [
      validate.required,
      validate.passRule,
      validate.passCaracter,
      validate.max,
    ],
    // Handle Error:
    handleError: {
      items: [],
    },
    // Edit
    edit: false,
    id_user: "",
  }),
  async mounted() {
    // =================================================== //
    // IF - Edit
    // =================================================== //

    if (!this.$route.params.id) {
      return;
    }

    this.edit = true;

    this.id_user = this.$route.params.id;
    let userData = await this.$request.post(
      "/regionalManager/locals/getLocal",
      { id_user: this.id_user }
    );

    const { nome, login } = userData.dados;

    this.form.fullName = nome;
    this.form.login = login;
  },
  computed: {
    dialog() {
      return this.$store.state.showDialog;
    },
    //
    // Confirm Password Rules:
    confirmPasswordRules() {
      const rules = [];
      const req = "required";
      if (req) {
        const rule = (v) => !!v || this.$t("rulesPassMatch");
        rules.push(rule);
      }
      if (this.form.confirmPassword) {
        const rule = (v) =>
          (!!v && v) === this.form.password || this.$t("repeatThePassword");
        rules.push(rule);
      }
      return rules;
    },
  },
  watch: {
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    //
    // updateLocal: Create or Edit Local Manager.
    async updateLocal() {
      if (!this.$refs.form.validate()) {
        return;
      }

      // Progress
      this.$store.commit("setFeedbackProgress", true);
      this.loading = true;

      // Body Request Verify Login
      const verifyLogin = {
        domain: this.$localStorage.getItem("user_data").db_name,
        login: this.form.login,
      };

      // Body Form
      const formUpdateLocalManager = {
        nome: this.form.fullName,
        login: this.form.login,
        password: this.form.password,
      };

      try {
        if (this.edit) {
          Object.assign(formUpdateLocalManager, { id_local: this.id_user });
        } else {
          // Verify Login:
          const verify = await this.$request.post(
            "main/fetchLogin",
            verifyLogin
          );
          if (verify.length == 0) {
            return;
          }
        }

        // Handle Endpoint
        const updateEndpoint = this.edit
          ? "regionalManager/locals/editLocal"
          : "regionalManager/locals/addLocal";

        const result = await this.$request.post(
          updateEndpoint,
          formUpdateLocalManager
        );
        if (result.length == 0) {
          return;
        }

        this.$store.commit("setFeedbackSnack", {
          msg: result.messages,
          color: "success",
        });

        if (!this.edit) {
          this.$refs.form.reset();
        }

        this.$store.commit("showDialog", false);
        this.$store.commit("setRefresh", true);
      } catch (error) {
        // Multiple error handler:
        if (error.response.status == 406) {
          const items = [];
          var obj = error.response.data.messages;
          for (var [key, value] of Object.entries(obj)) {
            const item = `${key}: ${value}`;
            items.push(item);
          }
          this.handleError.items = items;
        }
      } finally {
        this.loading = false;
      }
    },

    // Close Dialog
    closeDialog() {
      this.$store.commit("showDialog", false);
    },
  },
};
</script>
